export default __webpack_public_path__ + "static/media/followStep_check.b4fcb9ee.svg";